module.exports = __webpack_public_path__ + "static/Snowball X Privacy Policy-76165ae5766da9d419a02814bdb496ec.pdf";